<dx-popup
    class="popup"
    [width]="isPhone ? 300 : 480"
    [height]="305"
    [showTitle]="false"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="popupVisible"
>
    <div *dxTemplate="let data of 'content'">
        <p fxShow fxHide.xs>The requisition was {{mode === 'create' ? 'created' : 'updated'}} successfully, what do you like to do next?</p>
        <p fxShow fxHide.gt-xs>The requisition was {{mode === 'create' ? 'created' : 'updated'}}</p>
        <p fxShow fxHide.gt-xs> successfully, what do you like to do next?</p>
        <div fxLayout="row" fxLayoutAlign="space-between">
            <p>Create New Requisition</p>
            <dx-button [text]="'New'" (click)="redirectToNew()" height="26px" width="60px"></dx-button>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between">
            <p>Print Requisition</p>
            <dx-button [text]="'Print'" (click)="redirectToEdit()" height="26px" width="60px"></dx-button>
        </div>
        <div fxShow fxHide.xs fxLayout="row" fxLayoutAlign="space-between">
            <p>Print Labels</p>
            <dx-button [text]="'Print'" (click)="redirectToEdit()" height="26px" width="60px"></dx-button>
        </div>
      <div fxLayout="row" fxLayoutAlign="space-between">
        <p>Sign/Unsign Requisition</p>
        <dx-button [text]="'Go'" (click)="redirectToEdit()" height="26px" width="60px"></dx-button>
      </div>
        <div fxLayout="row" fxLayoutAlign="space-between">
            <p>Attach Documents</p>
            <dx-button [text]="'Attach'" (click)="redirectToEdit()" height="26px" width="60px"></dx-button>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between">
            <p>Go to Home Page</p>
            <dx-button [text]="'Go'" (click)="redirectToHome()" height="26px" width="60px"></dx-button>
        </div>
    </div>

</dx-popup>
